<template>
  <div class="returns-filter-section">
    <navigation-button
      class="returns-filter-button"
      :color="color"
      :icon="icon"
      :label="label"
      @click="toggle"
    />
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  import NavigationButton from '@/components/Navigation/Button.vue';

  export default {
    name: 'ReturnsListFilter',
    components: {
      NavigationButton,
    },
    computed: {
      ...mapState([
        'financingReturnRules',
      ]),

      active() {
       return this.financingReturnRules.list.filters.active;
      },
      icon() {
        return this.active ? 'times' : 'filter';
      },
      color() {
        return this.active ? 'red' : 'gray';
      },
      label() {
        return this.active ? 'Limpar filtros' : 'Filtros';
      },
    },
    methods: {
      toggle() {
        this.$store.dispatch('financingReturnRules/filter', {
          ...this.financingReturnRules.list.filters,
          active: !this.financingReturnRules.list.filters.active,
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .returns-filter-section {
    display: flex;
    justify-content: flex-end;
    min-width: $button;
    margin: 0 var(--product--pwa--horizontal);

    @media all and (min-width: $breakpoint-desktop) {
      margin: 0 var(--product--pwa--horizontal);
    }
  }

  .returns-filter-button {
    margin-bottom: $gutter;
  }
</style>
